import { Box, Button, Typography } from "@mui/material";

import ReauthAlert from "@app/analytics/account/components/ReauthAlert";
import { SSO_PROVIDERS_BY_ID } from "@app/common/constants/providers";
import type { SSOProviderId } from "@app/common/types/providerTypes";

import Stack, { Row } from "@rui/Stack";

interface SSOItemProps {
  providerId: SSOProviderId;
  onRemove?: (provider: SSOProviderId) => void;
  reauthRequired?: boolean;
  onReauthClick?: (id: SSOProviderId) => void;
}

const SSOItem = ({
  providerId,
  onRemove,
  reauthRequired,
  onReauthClick,
}: SSOItemProps) => {
  const provider = SSO_PROVIDERS_BY_ID[providerId];

  return (
    <Stack>
      <Row variant="apart" sx={{ minHeight: "40px", py: 1 }}>
        <Row variant="left" spacing={1}>
          <Box sx={{ height: "20px" }}>
            <Box
              component="img"
              sx={{ maxHeight: "100%" }}
              src={provider.icon}
              alt={provider.displayName}
            />
          </Box>
          <Typography
            variant="bodySecondaryMed"
            sx={{ color: "shades.neutral.800" }}
          >
            Sign-in with {provider.displayName} is enabled
          </Typography>
        </Row>
        {onRemove && (
          <Button color="error" onClick={() => onRemove(provider.id)}>
            Remove
          </Button>
        )}
      </Row>
      {onReauthClick && reauthRequired && (
        <ReauthAlert onReauthClick={onReauthClick} providerId={providerId} />
      )}
    </Stack>
  );
};

export default SSOItem;
